import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';

@Component({
  selector: 'app-new-order-modal',
  imports: [],
  templateUrl: './new-order-modal.html',
  styleUrl: './new-order-modal.css'
})
export class NewOrderModal {

  constructor(
    public dialogRef: MatDialogRef<NewOrderModal>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {
  }

  close(): void {
    this.dialogRef.close()
  }

  createNewOrder() {
    this.router.navigate(
      ['/home/pedidos/crear'],
      {queryParams: {related: false}}
    );
    this.close();
  }

  massiveLoad() {
    this.router.navigate(['/home/pedidos/carga-masiva'])
    this.close()
  }
}
